import { render, staticRenderFns } from "./TransactionResult.vue?vue&type=template&id=5a97271e&"
import script from "./TransactionResult.vue?vue&type=script&lang=js&"
export * from "./TransactionResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports